// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__MygNU","left":"StickyBox_left__17OK_","right":"StickyBox_right__2errT"};